const ModalTheme = {
  show: "transform-none",
  static: "!scale-[1.02]",
  staticProperties: "transition-scale duration-300 ease-in-out",
  wrapper:
    "fixed left-0 top-0 z-[1055] h-full w-full overflow-y-auto overflow-x-hidden outline-none",
};

export default ModalTheme;
